export default __webpack_public_path__ + "_static_/media/cloud-logo.10405b43.svg";